import React, { useState } from "react";
import "./App.css";
import "./DatePicker.css";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import {
  Login,
  ConfirmCode,
  OrderCondition,
  OrdersList,
  Profile,
  Wallet,
  LiveLocation,
  TaxiRequests,
  TaxiReqCondition,
  Support,
  SupportNewMessage,
  SupportScore,
  ChoosePanel,
} from "./Pages/index";
import { ToastContainer } from "react-toastify";
import { getTokens } from "./firebase";
import CooperationRequest from "./Pages/CooperationRequest/CooperationRequest";
import SupportChat from "./Pages/Support/SupportChat/SupportChat";

function App() {
  const [isTokenFound, setTokenFound] = useState(false);
  if (!!localStorage.getItem("JwtTokens")) {
    if (!isTokenFound) {
      getTokens(setTokenFound);
    }
  }

  const isLogin = () => !!localStorage.getItem("JwtTokens");

  const PublicRoute = ({ component, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) return <Redirect to="/" />;
          else {
            return React.createElement(component);
          }
        }}
      />
    );
  };

  const PrivatRoute = ({ render, ...props }) => {
    return (
      <Route
        {...props}
        render={(props) => {
          if (isLogin()) return render(props);
          else {
            return <Redirect to="/login" />;
          }
        }}
      />
    );
  };
  return (
    <Router>
      <Switch>
        <PublicRoute
          exact
          path="/cooperationrequest"
          component={CooperationRequest}
        />
        <PublicRoute exact path="/login" component={Login} />
        <Route exact path="/confirm" component={ConfirmCode} />
        <Route exact path="/live" component={LiveLocation} />
        <PrivatRoute
          path="/"
          render={() => (
            <Switch>
              <Route exact path="/deliverypanel/ordercondition" component={OrderCondition} />
              {/* <Route exact path="/" component={OrderCondition}/> */}
              <Route exact path="/deliverypanel" component={OrdersList} />
              <Route exact path="/" component={ChoosePanel} />
              <Route exact path="/deliverypanel/profile" component={Profile} />
              <Route exact path="/taxireq/profile" component={Profile} />
              <Route exact path="/taxireq" component={TaxiRequests} />
              <Route
                exact
                path="/taxireq/taxireqcondition"
                component={TaxiReqCondition}
              />
              <Route exact path="/support" component={Support} />
              <Route exact path="/newmessage" component={SupportNewMessage} />
              <Route exact path="/supportchat/:id" component={SupportChat} />
              <Route exact path="/supportscore/:id" component={SupportScore} />
              <Route exact path="/کیف_پول" component={Wallet} />
            </Switch>
          )}
        />
      </Switch>
      <ToastContainer limit={3} />
    </Router>
  );
}

export default App;
